<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters class="flex-nowrap">
        <v-col class="flex-grow-1 py-1 px-2">
          <v-row
            no-gutters
            class="justify-space-between text-body-2 font-weight-medium data-tree-table-header"
            align="center"
          >
            <v-col
              cols="auto"
              v-for="(header, idx) of headers"
              :key="idx"
              :style="
                `width: ${idx === 0 ? headerWidth * 2 : headerWidth}%; padding-left: ${idx === 0 ? '27px' : '0px'}`
              "
              :class="{ 'text-left': idx === 0, 'text-right': headers.length === 2 && idx === 1 }"
            >
              {{ header.translationStraight || $i18n.t(header.translationPath) }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="data-tree-table">
        <v-col cols="12">
          <data-tree-table-row
            v-for="(element, idx) of dataTreeResult"
            :key="idx"
            :element="element"
            :headers="headers"
            :disable-zoom="disableZoom"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import DataTreeTableRow from '@/components/DataTreeTableRow';
export default {
  name: 'DataTreeTable',
  components: { DataTreeTableRow },
  props: {
    dataTree: {
      type: Object,
      required: true,
    },
    dataTreeResult: {
      type: Array,
      default: () => {
        return [];
      },
    },
    headers: {
      type: Array,
      default: () => {
        return [
          { key: 'name', translationPath: 'sidebar.dataTree.name' },
          { key: 'area', translationPath: 'sidebar.dataTree.area' },
        ];
      },
    },
    disableZoom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerWidth() {
      return 100 / (this.headers.length + 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.data-tree-table-header {
  color: rgba(0, 0, 0, 0.59);
}
.data-tree-table {
  @include border(all);
}
.data-tree-table-level-tab {
  padding-left: 20px;
}
</style>
